export const getMedicationForDescription = (d: string) => {
  if (d.includes("semaglutide")) {
    return "semaglutide";
  }

  if (d.includes("tirzepatide")) {
    return "tirzepatide";
  }

  if (d.includes("metformin")) {
    return "metformin";
  }

  return d;
};
